module.exports = __webpack_public_path__ + "img/ciaz-blanco-horizonte.b1eebfbf.png";